export function getIntervalID() {
    return localStorage.getItem("intervalID");
}
export function setIntervalID(intervalID) {
    localStorage.setItem("intervalID", intervalID);
}
export function removeIntervalID() {
    localStorage.removeItem("intervalID");
}